module.exports = __webpack_public_path__ + "static/media/Img_5.bf3e634d.jpg";